import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { Link } from "react-router-dom";
import { componentColors, componentStyles, fontSize } from '../../theme';

interface PageContainerProps {
  isMobile?: boolean;
}

export const PageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <PageContainerProps>`
  height: 100%;
  background-color: ${componentColors.pageBackground};
  color: ${componentColors.pageContrast};
  box-sizing: border-box;
  padding: ${({ isMobile }) => (isMobile ? "16px 8px 16px" : "24px")};
  font-size: ${({ isMobile }) => (isMobile ? `${fontSize.mobile}px` : `${fontSize.default}px`)};
  overflow-y: scroll;
`

export const CardContainer = styled(Box)`
  background-color: ${componentColors.card};
  border: 1px solid ${componentColors.cardBorder};
  border-radius: ${componentStyles.cardRadius};
  overflow: hidden;
`

export const CardBtn = styled(CardContainer)`
  transition: transform 0.1s ease;
  &:hover {
    border-color: ${componentColors.selectedItem};
    box-shadow: 0px 0px 8px ${componentColors.selectedItem}60;
    transform: scale(1.03);
  }
`;

export const LinkStyled = styled(Link)`
  text-decoration: none;
  color: inherit;
`;
